var map = {
	"./404.svg": 972,
	"./Categories.png": 721,
	"./Edit-menu.svg": 973,
	"./Egg.svg": 974,
	"./Emaier-Header.png": 975,
	"./Qr-4.png": 976,
	"./_duplicate.svg": 977,
	"./_overview.svg": 978,
	"./add-white.svg": 979,
	"./alert.svg": 980,
	"./all_category.svg": 981,
	"./archive.svg": 982,
	"./armchair.svg": 983,
	"./arrow-circle-right.svg": 984,
	"./arrow-left-circle.svg": 985,
	"./arrow-right-circle.svg": 986,
	"./arrow-right.svg": 987,
	"./asc-up-white.svg": 988,
	"./asc.png": 989,
	"./asc.svg": 990,
	"./back-arrow.svg": 991,
	"./barcode-icon.svg": 992,
	"./beverages.svg": 993,
	"./blue-edit-pen.svg": 994,
	"./blue-eye.svg": 995,
	"./box-office.svg": 996,
	"./broken-seat.jpg": 997,
	"./calendar_list.svg": 998,
	"./calender.svg": 368,
	"./chevron-down.svg": 999,
	"./chevron-left.svg": 1000,
	"./cinema-mamagement-sidebar.svg": 1001,
	"./claendar.svg": 369,
	"./clock-1.svg": 1002,
	"./clock.svg": 1003,
	"./close-button.svg": 728,
	"./close-white.svg": 734,
	"./close-x.svg": 312,
	"./collapse-up.svg": 1004,
	"./collapse.svg": 1005,
	"./connection-lost.svg": 366,
	"./consumable-raw-material.svg": 1006,
	"./copy.svg": 1007,
	"./copy_image_icon.png": 1008,
	"./delete-red-light.svg": 1009,
	"./delete-red.svg": 735,
	"./delete.svg": 709,
	"./deliver-icon.svg": 1010,
	"./desc-down-white.svg": 1011,
	"./desc.svg": 1012,
	"./distributors-sidebar.svg": 1013,
	"./download.svg": 1014,
	"./dragndrop.svg": 1015,
	"./dragndrop2.svg": 1016,
	"./duplicate.svg": 1017,
	"./duplicateScreen.svg": 1018,
	"./e-wallet-icon-black.svg": 1019,
	"./edit-pen-blue.svg": 1020,
	"./edit-pen-white.svg": 1021,
	"./edit-pen.svg": 1022,
	"./edit.svg": 1023,
	"./email.png": 1024,
	"./empty-image.svg": 1025,
	"./excel.svg": 1026,
	"./external-link.svg": 1027,
	"./eye.svg": 1028,
	"./filter-icon.svg": 1029,
	"./flag.svg": 1030,
	"./fnb-app-order.svg": 1031,
	"./fnb-beverages.svg": 1032,
	"./fnb-brownie.svg": 1033,
	"./fnb-combo.svg": 1034,
	"./fnb-desert.svg": 1035,
	"./fnb-eatables.svg": 1036,
	"./fnb-make-your-combo.svg": 1037,
	"./fnb-popcorn.svg": 1038,
	"./fnbtransactionIcon.svg": 1039,
	"./fullscreen-icon.svg": 736,
	"./funnel.svg": 1040,
	"./globe.svg": 1041,
	"./green-tick.svg": 1042,
	"./grid-view.svg": 1043,
	"./hide-password.svg": 370,
	"./home-icon.svg": 1044,
	"./home.svg": 1045,
	"./icon-black-play.svg": 1046,
	"./icon-dot.svg": 1047,
	"./icon-fnb.svg": 1048,
	"./icon-marketing.svg": 1049,
	"./icon-no-seat.png": 1050,
	"./icon-no-seat.svg": 1051,
	"./icon-option.svg": 1052,
	"./icon-poin-of-sale.svg": 1053,
	"./icon-recliner.svg": 1054,
	"./icon-report.svg": 1055,
	"./icon-sofa-dark-1.svg": 1056,
	"./icon-sofa-dark.png": 1057,
	"./icon-sofa-dark.svg": 1058,
	"./icon-sofa.svg": 1059,
	"./importfile.svg": 1060,
	"./info.svg": 737,
	"./info2.svg": 1061,
	"./keyboard-icon.svg": 1062,
	"./kitchen_display.svg": 1063,
	"./language-icon.svg": 1064,
	"./left-caret.svg": 1065,
	"./link.svg": 1066,
	"./list-view.svg": 1067,
	"./loading.svg": 371,
	"./lock.svg": 1068,
	"./login-password.png": 372,
	"./login-user.png": 373,
	"./logout.svg": 738,
	"./masters-sidebar.svg": 1069,
	"./merchandise.svg": 1070,
	"./minus.svg": 1071,
	"./movie-pass-svg.svg": 719,
	"./movie-rolling.svg": 1072,
	"./mulitSchedule.svg": 1073,
	"./multicurrency.svg": 1074,
	"./multifnb.svg": 1075,
	"./nav-plus.svg": 1076,
	"./new_filter_icon.svg": 1077,
	"./no-image.svg": 1078,
	"./no-schedule.svg": 144,
	"./non-veg-mark.png": 1079,
	"./non-veg-mark.svg": 1080,
	"./notification.svg": 1081,
	"./open-link-blue.svg": 1082,
	"./openPlanned.svg": 1083,
	"./overview.svg": 1084,
	"./overview2.svg": 1085,
	"./pdf-icon.svg": 1086,
	"./pdf.svg": 1087,
	"./pickup-ticket-icon.svg": 1088,
	"./pickupfnb.svg": 1089,
	"./play.svg": 1090,
	"./plus.svg": 1091,
	"./pointofsale-1.svg": 1092,
	"./pointofsale-2.svg": 1093,
	"./pointofsale.png": 1094,
	"./portfolio.svg": 1095,
	"./pos-fnb-no-itmes.svg": 722,
	"./pos-refresh.svg": 1096,
	"./primary/chevron-down.svg": 1097,
	"./primary/download.svg": 1098,
	"./primary/edit.svg": 1099,
	"./primary/filter.svg": 1100,
	"./primary/printer.svg": 1101,
	"./print-icon.svg": 1102,
	"./print.svg": 1103,
	"./question.svg": 1104,
	"./question1.svg": 1105,
	"./question2.svg": 739,
	"./question3.svg": 1106,
	"./recliner-1.svg": 1107,
	"./recliner.png": 1108,
	"./refund-icon.svg": 1109,
	"./reload-icon-pos.svg": 1110,
	"./reload-icon.svg": 1111,
	"./restore.svg": 1112,
	"./right-caret.svg": 1113,
	"./role-management-sidebar.svg": 1114,
	"./save.svg": 1115,
	"./schedule-icon.svg": 1116,
	"./school-calendar.svg": 1117,
	"./search-global-white.svg": 1118,
	"./search-global.svg": 1119,
	"./search.svg": 740,
	"./searchIcon.svg": 1120,
	"./seat-icon-2.svg": 1121,
	"./seat-icon.svg": 1122,
	"./seat-icons/3-wheelChair.png": 1123,
	"./seat-icons/block_seat_new.png": 1124,
	"./seat-icons/broken-seat-1.svg": 1125,
	"./seat-icons/broken-seat-2.svg": 1126,
	"./select-food.png": 741,
	"./settings.svg": 1127,
	"./show-password.svg": 374,
	"./slider-triangle.svg": 731,
	"./snack.svg": 742,
	"./sort.svg": 1128,
	"./star-empty.svg": 1129,
	"./star-fill.svg": 1130,
	"./success-tick.svg": 1131,
	"./suitcase.svg": 1132,
	"./swap.svg": 1133,
	"./tick-green-item.svg": 743,
	"./tick-green.svg": 1134,
	"./ticket-icon.svg": 1135,
	"./trash.svg": 1136,
	"./unpaid-reservation.svg": 713,
	"./updown-white.svg": 1137,
	"./updown.svg": 1138,
	"./user-attribute.svg": 1139,
	"./user-attributes.svg": 1140,
	"./user-female.svg": 1141,
	"./user-male-white.svg": 1142,
	"./user-male.svg": 1143,
	"./user-profile.svg": 1144,
	"./userProfile.png": 1145,
	"./veg-food-mark-white.png": 1146,
	"./veg-foog-mark-trans.png": 1147,
	"./view.png": 1148,
	"./view.svg": 1149
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 971;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 971
// module chunks = 38